import React from 'react'
import DateInput from './DateInput'

export default function DateRangeInput(props) {
  return (
    <React.Fragment>
      <DateInput
        label={props.fromLabel}
        placeholder={props.fromPlaceholder}
        disabled={props.disabled}
        loading={props.loading}
        transparent={props.transparent}
        error={props.error}
        format={props.format}
        value={props.from}
        onChange={props.onFromChange}
      />

      <DateInput
        label={props.toLabel}
        placeholder={props.toPlaceholder}
        disabled={props.disabled}
        loading={props.loading}
        transparent={props.transparent}
        error={props.error}
        format={props.format}
        value={props.to}
        onChange={props.onToChange}
      />
    </React.Fragment>
  )
}

DateRangeInput.defaultProps = {
  disabled: false,
  loading: false,
  transparent: false,
  error: false,
  format: 'dd/MM/yyyy',
  fromLabel: 'Fecha Inicio',
  fromPlaceholder: 'Fecha Inicio',
  from: null,
  onFromChange: () => {},
  toLabel: 'Fecha Fin',
  toPlaceholder: 'Fecha Fin',
  to: null,
  onToChange: () => {},
}
